import { render, staticRenderFns } from "./ClientAccountWithTagsPicker.vue?vue&type=template&id=be0661b0"
import script from "./ClientAccountWithTagsPicker.vue?vue&type=script&lang=js"
export * from "./ClientAccountWithTagsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports